import React from "react";
import Button from "./Button";

/**
 * Пагинация списков — те же кнопки, что и везде в приложении.
 *
 * <Pagination
 *   page={pagination.page}
 *   totalPages={totalPages}
 *   onChange={handlePageClick}
 * />
 */
const Pagination = ({
    page = 1,
    totalPages = 1,
    onChange,
    className = "mx-1",
}) => {
    if (totalPages <= 1) return null;

    const renderPage = (label, target, active, key) => (
        <Button
            key={key}
            className={className}
            onClick={() => onChange(target)}
            size="sm"
            variant={active ? "primary" : "secondary"}>
            {label}
        </Button>
    );

    if (totalPages < 5) {
        return Array.from({ length: totalPages }, (_, idx) => {
            const pageNum = idx + 1;
            return renderPage(pageNum, pageNum, pageNum === page, pageNum);
        });
    }

    let start = Math.max(1, page - 1);
    let end = start + 2;
    if (end > totalPages) {
        end = totalPages;
        start = end - 2;
    }

    const buttons = [];

    if (start > 1) {
        buttons.push(renderPage("...", start - 1, false, "left-ellipsis"));
    }

    for (let p = start; p <= end; p++) {
        buttons.push(renderPage(p, p, p === page, p));
    }

    if (end < totalPages) {
        buttons.push(renderPage("...", end + 1, false, "right-ellipsis"));
    }

    return buttons;
};

export default Pagination;
